import React from "react";
import { Link, useLocation } from "react-router-dom";
import { PartyPopper } from "lucide-react";

export default function FloatingReserve() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/reservations") || pathname.startsWith("/admin")) return null;
  return (
    <Link to="/reservations"
      className="sm:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-40 btn-primary px-7 py-3.5 flex items-center gap-2 text-sm"
      data-testid="floating-reserve-btn">
      <PartyPopper size={18} /> Reserve Now
    </Link>
  );
}
